const state = {
  stateValue: 0,
  edit: false,
  editId: 0,
  methodsInfo: {},
  FlashColumnList: [],
  /**
   * 色谱柱填料类别
   * */
  columnFillerType: [
    {
      value: "C18",
      label: "C18",
    },
    {
      value: "CB",
      label: "CB",
    },
    {
      value: "硅胶",
      label: "硅胶",
    },
    {
      value: "氨基",
      label: "氨基",
    },
    {
      value: "HILIC",
      label: "HILIC",
    },
  ],

  /**
   * 流动相设置
   * */
  FlowPhase: [
    {
      value: "",
      label: "",
    },
  ],
  /**
   * 分析方法
   * */
  analysisMethodType: [
    {
      value: 0,
      label: "TLC薄层色谱",
    },
    {
      value: 1,
      label: "HPLC高效液相色谱",
    },
  ],
  /**
   * TLC 薄层
   * */
  TLCType: [
    {
      value: "硅胶",
      label: "硅胶",
    },
    {
      value: "C18",
      label: "C18",
    },
    {
      value: "氧化铝",
      label: "氧化铝",
    },
  ],

  /**
   * 样品处理类型
   * */
  processType: [
    {
      value: 0,
      label: "稀释溶解",
    },
    {
      value: 1,
      label: "固体拌样",
    },
  ],

  /**
   * 检测类型
   * */
  detectSettingType: [
    {
      value: "0",
      label: "UV",
    },
    {
      value: "1",
      label: "ELSD",
    },
  ],
  methodType: [
    {
      value: "0",
      label: "正相分离",
    },
    {
      value: "1",
      label: "反相分离",
    },
  ],
  /**
   * 样品收集类型
   * */
  simpleCollectType: [
    {
      value: "0",
      label: "自动试管架",
    },
    {
      value: "1",
      label: "自定义试管架",
    },
  ],

  gradientType: [
    {
      value: 0,
      label: "二元",
    },
    {
      value: 1,
      label: "四元",
    },
  ],

  /**
   * 方法ID
   * */
  id: 0,

  /**
   * 0. 基础信息
   * */
  baseInfo: {
    /**
     * 版本控制信息
     * */
    version: "",
    /**
     * 是否已验证 0:未验证  1:已验证
     * */
    validateState: 0,
  },

  /**
   * 1. 作者信息
   * */
  author: {
    username: "",
    organization: "",
    email: "",
  },
  /**
   * 2. 目标化合物信息
   * */
  SampleInfo: {
    CAS: "",
    Project: "",
    TargetSmiles: "",
    TargetMolfile: "",
    TargetStructure: "",
    TargetName: "",
    TargetPic: "",
    ReactantList: [],
  },

  /**
   * 2. 起始化合物信息
   * */
  startObjects: [
    {
      name: "",
      png: "",
      cas: "",
      smile: "",
    },
  ],

  /**
   * 3.原始样品分析与鉴定
   *
   * */
  sampleAnalysis: {
    type: 0, //0: TLC方法   1:HPLC方法
    remark: "",
    tlc: {
      tlc: "", //1: 氧化铝 2:C18
      tlcLabel: "",
      solvents: [
        {
          solvent: "",
          percent: "",
          SolventEn: "",
          Polarity: "",
        },
      ], //展开剂
      tlcPic: "", //TLC图片
      tlcColor: "", //自定义显色方式
      tlcColorType: 1, //显色方式
    },
    hplc: {
      flashColumn: {
        type: "", //1:C18  2:CB  3:硅胶  4:氨基  5:HILIC
        typeLabel: "C18",
        spec: "", // 规格
        particleSize: "", //粒径
        aperture: "120Å", //孔径
      },
      flowPhase: [], //1: 水  2: 乙腈
      gradientList: [
        {
          PercentA: "",
          PercentB: "",
          PercentC: "",
          PercentD: "",
          Time: "",
          CV: "",
          SolvChannel: "",
          FixedPercent: "",
          FixedChannel: "",
        },
      ], //洗脱梯度
      targetSaveTime: "", //目标保留时间(min)
      targetPurity: "", //目标纯度(%)
      hplcPic: "", //hplc图片
      flowA: "",
      flowB: "",
      hplcflowA: [],
      hplcflowB: [],
    },
  },

  //6. TLC展开剂
  SolventList: [
    {
      Solvent: "",
      Percent: "",
      SolventEn: "",
      Polarity: "",
    },
    {
      Solvent: "",
      Percent: "",
      SolventEn: "",
      Polarity: "",
    },
  ],

  /**
   * 3. TLC 正相参数列表
   */
  RFList: [
    {
      Value: "",
      RFFlag: 0,
      level: "Rf1",
    },
    {
      Value: "",
      RFFlag: 0,
      level: "Rf2",
    },
    {
      Value: "",
      RFFlag: 0,
      level: "Rf3",
    },
  ],
  // RTList: [{
  //     Value: "",
  //     RTFlag: '1'
  // }],
  RTList: [
    {
      Area: "",
      ComponentIndex: 1,
      TFlag: "",
      Time: "",
      Percent: "",
    },
  ],
  //5. 流速
  // FlowRateList: [{
  //     Time: "",
  //     Value: ""
  // }],
  /**
   * 新增加
   * */
  IsFour: 0,

  //5. 梯度
  GradientList: [
    {
      begin_cv: "0.0",
      end_cv: "",
      flow_rate: "",
      begin_time: "0.0",
      end_time: "",
      channel_1: "",
      channel_2: "",
      channel_3: "N",
      percent_3: "",
      begin_percent_2: "",
      end_percent_2: "",
    },
  ],
  //4. 样品准备
  SamplePrepare: {
    preProcessType: 1, //1. 稀释溶解  2.固体拌样
    dilution: {
      sampleWeight: "", //样品质量
      dilutionSolvents: "",
      dilutionVolume: "",
      unit: "g",
    },
    solidMix: {
      sampleWeight: "", //样品质量
      mixObject: "", //拌样介质
      mixObjectWeight: "", //拌样介质重量(g)
      unit: "g",
    },
  },
  //5. 分离参数
  MethodInfo: {
    text3: "",
    yieldUnit: "mg",
    extract_user: "",
    quote_number: 0,
    wavelengthChA: "", //检测方式UV
    wavelengthChB: "", //检测方式UV
    uuid: "",
    analysisColumn: "",
    method_time: new Date(),
    evaluate_level: "",
    method_name: "",
    loadAmount: "", //进样量
    loadAmountUnit: "g",
    method_location: "",
    method_security: "",
    collectionThreshold: "",
    gradientType: 1,
    id: 0,
    is_self: "",
    project_uuid: "",
    collectionMode: "",
    create_time: "",
    method_type: "0",
    rawconPath: "", //整体合成图片找事
    spectrum_number: "",
    sampleWeight: "",
    create_user: "",
    flashColumn: "", //品牌型号
    columns: [],
    //分离柱详细信息
    columnDetail: {
      flashColumn: "",
      cv: "",
      filler: "",
      aperture: "",
      catalogueName: "",
      particleSize: "",
      pressure: "",
      trailingFactorMin: "",
      trailingFactorMax: "",
      resolution: "",
      supplierName: "",
      length: "",
      innerDiameter: "",
      supplierId: "",
      brand: "",
      // cv: '', //柱体积(新增)
      // fillerType: '', //填料类型
      // fillerLabel: '',
      // fillerParticleSize:'', //填料粒径
      // fillerAperture:'', //填料孔径
      // spec:'', //规格(G)
      // size:'' //尺寸
    },
    solvents: [], //洗脱溶剂(String[])
    loadType: "", //上样类型
    detectSetting: "0", //检测设置
    atomizationTemperature: "", //雾化温度(ELSD)检测设置时用到
    //样品收集
    sampleCollection: {
      collectType: "0", //收集类型 ：自动收集、手动收集
      perCollectVol: "", //每一容器收集体积
    },
    otherInfo: {
      separateTime: "", //分离时间(min)
      totalCollectNum: "", //总计收集容器数量
      //溶剂消耗
      solventsConsume: [
        {
          solvents: "",
          vol: "",
        },
      ],
      evaluateScoreInfo: "",
    },
  },
  /**
   * 5. 色谱图地址(其他运行信息中添加)
   * */
  Chromatographic: "",

  /**
   * 6.纯度及结果认定
   * */
  purityResConfirmation: {
    type: 0, //1: TLC方法   2:HPLC方法
    tlc: {
      tlc: "", //1: 氧化铝 2:C18
      remark: "",
      tlcLabel: "",
      solvents: [
        {
          Solvent: "",
          Percent: "",
          SolventEn: "",
          Polarity: "",
        },
        {
          Solvent: "",
          Percent: "",
          SolventEn: "",
          Polarity: "",
        },
      ], //展开剂
      tlcPic: "", //TLC图片
    },
    hplc: {
      flashColumn: {
        type: "", //1:C18  2:CB  3:硅胶  4:氨基  5:HILIC
        analysis_column: "",
        flow_rate: "",
        particle_diameter: "",
        inner_diameter: "",
        length: "",
      },
      flowPhase: [], //1: 水  2: 乙腈
      hplcPic: "", //hplc图片
      flowA: "",
      flowB: "",
      hplcflowA: [],
      hplcflowB: [],
    },
  },
  /**
   * 7.综合评价
   * */
  EvaluateSet: {
    text1: "是",
    text2: "",
    text3: "",
    text4: "",
    text5: "",
    yieldUnit: "g",
  },
  /**
   * 8. 品牌
   * */
  MachineInfo: {
    brand: "",
    type: "",
  },
  sepaMethodUpdate: {},
  remark: "", //备注
};

const mutations = {
  updateMachineInfo(state, MachineInfo) {
    state.MachineInfo = MachineInfo;
  },
  updateMethodsInfo(state, form) {
    state.methodsInfo = form;
  },
  updateMethodId(state, id) {
    state.id = id;
  },
  updateBaseInfo(state, baseInfo) {
    state.baseInfo = baseInfo;
  },
  updateAuthorInfo(state, author) {
    state.author = author;
    // console.log(`authos is ${author}`)
  },
  updateSampleInfo(state, SampleInfo) {
    state.SampleInfo = SampleInfo;
    // console.log(`sample info is ${SampleInfo}`)
  },
  updateFlashColumnList(state, FlashColumnList) {
    state.FlashColumnList = FlashColumnList;
  },
  updateStartObjects(state, startObjects) {
    state.startObjects = startObjects;
    // console.log(`startObject is ${startObjects}`)
  },
  updateSampleAnalysis(state, sampleAnalysis) {
    state.sampleAnalysis = sampleAnalysis;
    // console.log(`sample analysis is ${sampleAnalysis}`)
  },
  updateSamplePrepare(state, SamplePrepare) {
    state.SamplePrepare = SamplePrepare;
    // console.log(`sample prepare is ${state.SamplePrepare}`)
  },
  updateFlowRateList(state, FlowRateList) {
    state.FlowRateList = FlowRateList;
    // console.log(`FlowRateList is ${FlowRateList}`)
  },
  updateIsFour(state, IsFour) {
    state.IsFour = IsFour;
    //   console.log(`IsFour is ${IsFour}`)
  },
  updateGradientList(state, GradientList) {
    state.GradientList = GradientList;
    // console.log(`GradientList is ${GradientList}`)
  },
  updateMethodInfo(state, MethodInfo) {
    state.MethodInfo = MethodInfo;
    // console.log(`MethodInfo is ${MethodInfo}`)
  },
  updateChromatographic(state, Chromatographic) {
    state.Chromatographic = Chromatographic;
    // console.log(`Chromatographic is ${Chromatographic}`)
  },
  updatePurityResConfirmation(state, form) {
    state.purityResConfirmation = form;
    // console.log(`purity result comfirm is ${form}`)
  },
  updateRFList(state, RFList) {
    state.RFList = RFList;
    // console.log(`RFList is ${state.RFList}`)
  },
  updateRTList(state, RTList) {
    state.RTList = RTList;
  },
  updateSolventList(state, SolventList) {
    state.SolventList = SolventList;
    // console.log(`SolventList is ${state.SolventList}`)
  },
  updateEvaluateSet(state, evaluateSet) {
    state.EvaluateSet = evaluateSet;
    // console.log(`evaluate set is ${state.EvaluateSet}`)
  },
  upateMachineInfo(state, machineInfo) {
    state.MachineInfo = machineInfo;
    // console.log(`machine info is ${state.MachineInfo}`)
  },
  // updateColumnFillerType(state, columnFillerType) {
  //     state.columnFillerType = columnFillerType;
  //     console.log(`columnFillerType is ${state.columnFillerType}`)
  // },
  // updateTLCType(state, TLCType) {
  //     state.TLCType = TLCType;
  //     console.log(`TLCType is ${state.TLCType}`)
  // },
  updateFlowPhase(state, FlowPhase) {
    state.FlowPhase = FlowPhase;
    // console.log(`FlowPhase is ${state.FlowPhase}`)
  },
};

const actions = {
  updateMethodId({ commit }, id) {
    commit("updateMethodId", id);
  },
  updateBaseInfo({ commit }, baseInfo) {
    commit("updateBaseInfo", baseInfo);
  },
  updateAuthorInfo({ commit }, author) {
    commit("updateAuthorInfo", author);
  },
  updateSampleInfo({ commit }, sampleInfo) {
    commit("updateSampleInfo", sampleInfo);
  },
  updateFlashColumnList({ commit }, FlashColumnList) {
    commit("updateFlashColumnList", FlashColumnList);
  },
  updateStartObjects({ commit }, startObjects) {
    commit("updateStartObjects", startObjects);
  },
  updateSampleAnalysis({ commit }, sampleAnalysis) {
    commit("updateSampleAnalysis", sampleAnalysis);
  },
  updateSamplePrepare({ commit }, samplePrepare) {
    commit("updateSamplePrepare", samplePrepare);
  },
  updateFlowRateList({ commit }, flowRateList) {
    commit("updateFlowRateList", flowRateList);
  },
  updateIsFour({ commit }, IsFour) {
    commit("updateIsFour", IsFour);
  },
  updateGradientList({ commit }, gradientList) {
    commit("updateGradientList", gradientList);
  },
  updateMethodInfo({ commit }, methodInfo) {
    commit("updateMethodInfo", methodInfo);
  },
  updateChromatographic({ commit }, chromatographic) {
    commit("updateChromatographic", chromatographic);
  },
  updatePurityResConfirmation({ commit }, form) {
    commit("updatePurityResConfirmation", form);
  },
  updateRFList({ commit }, rfList) {
    commit("updateRFList", rfList);
  },
  updateRTList({ commit }, rtList) {
    commit("updateRTList", rtList);
  },
  updateSolventList({ commit }, solventList) {
    commit("updateSolventList", solventList);
  },
  updateEvaluateSet({ commit }, evaluateSet) {
    commit("updateEvaluateSet", evaluateSet);
  },
  updateMachineInfo({ commit }, machineInfo) {
    commit("updateMachineInfo", machineInfo);
  },
  // updateColumnFillerType({commit}, columnFillerType) {
  //     commit('updateColumnFillerType', columnFillerType);
  // },
  // updateTLCType({commit}, TLCType) {
  //     commit('updateTLCType', TLCType)
  // },
  updateFlowPhase({ commit }, FlowPhase) {
    commit("updateFlowPhase", FlowPhase);
  },
  updateSepaMethod({ commit }, sepaMethod) {
    if (sepaMethod.id != undefined) {
      commit("updateMethodId", sepaMethod.id);
    }

    if (sepaMethod.sampleAnalysis != undefined) {
      commit("updateSampleAnalysis", sepaMethod.sampleAnalysis);
    }

    if (sepaMethod.RFList != undefined) {
      commit("updateRFList", sepaMethod.RFList);
    }
    if (sepaMethod.RTList != undefined) {
      commit("updateRTList", sepaMethod.RTList);
    }

    if (sepaMethod.SolventList != undefined) {
      commit("updateSolventList", sepaMethod.SolventList);
    }
    if (sepaMethod.EvaluateSet != undefined) {
      commit("updateEvaluateSet", sepaMethod.EvaluateSet);
    }
    if (sepaMethod.MachineInfo != undefined) {
      commit("updateMachineInfo", sepaMethod.MachineInfo);
    }
    if (sepaMethod.FlowRateList != undefined) {
      commit("updateFlowRateList", sepaMethod.FlowRateList);
    }
    if (sepaMethod.IsFour != undefined) {
      commit("updateIsFour", sepaMethod.IsFour);
    }
    if (sepaMethod.GradientList != undefined) {
      commit("updateGradientList", sepaMethod.GradientList);
    }
    if (sepaMethod.MethodInfo != undefined) {
      commit("updateMethodInfo", sepaMethod.MethodInfo);
    }
    if (sepaMethod.Chromatographic != undefined) {
      commit("updateChromatographic", sepaMethod.Chromatographic);
    }
    if (sepaMethod.SampleInfo != undefined) {
      commit("updateSampleInfo", sepaMethod.SampleInfo);
    }
    if (sepaMethod.FlashColumnList != undefined) {
      commit("updateFlashColumnList", sepaMethod.FlashColumnList);
    }
    if (sepaMethod.startObjects != undefined) {
      commit("updateStartObjects", sepaMethod.startObjects);
    }
    if (sepaMethod.purityResConfirmation != undefined) {
      commit("updatePurityResConfirmation", sepaMethod.purityResConfirmation);
    }
    if (sepaMethod.SamplePrepare != undefined) {
      commit("updateSamplePrepare", sepaMethod.SamplePrepare);
    }

    if (sepaMethod.MachineInfo != undefined) {
      commit("upateMachineInfo", sepaMethod.MachineInfo);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
